import React, { useState, useEffect } from 'react';
import axios from 'axios';
import SideNavbar from './helpers/SideNavbar';
import moment from 'moment-timezone';
import { Modal, Button } from 'react-bootstrap';
import { faTrash, faRefresh, faSpinner, faArrowRotateLeft, faImage, faVideo, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Swal from 'sweetalert2';
import noDataImage from "../assets/nodata.png"
import { Link, useNavigate } from 'react-router-dom';
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import ReactPaginate from 'react-paginate';


const ViewAllApprovedPosts = () => {
    const navigate = useNavigate()
    const [posts, setPosts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [postToDeactivate, setPostToDeactivate] = useState(null);
    const [showDeactivateModal, setShowDeactivateModal] = useState(false);
    const [deactivating, setDeactivating] = useState({});
    const [expandedPosts, setExpandedPosts] = useState({});
    const [showMediaModal, setShowMediaModal] = useState(false);
    const [activeMedia, setActiveMedia] = useState(null);
    const UserID = localStorage.getItem("UserID");

    const [currentPage, setCurrentPage] = useState(0);
    const postsPerPage = 4; // Set the number of posts per page

    const styles = {
        pageCard: { border: 'none', backgroundColor: 'transparent' },
        headerBar: { borderRadius: '18px', padding: '18px 24px', backgroundColor: '#ffffff', border: '1px solid #eef0f8' },
        headerTitle: { fontSize: '22px', color: '#2e3192', fontWeight: 700, margin: 0 },
        refreshButton: { borderRadius: '999px', paddingInline: '18px', paddingBlock: '10px', fontWeight: 600 },
        gridRow: { marginTop: '4px', alignItems: 'stretch' },
        card: { borderRadius: '22px', border: '1px solid #eef0f8', padding: '24px', backgroundColor: '#ffffff', height: '100%', display: 'flex', flexDirection: 'column', overflow: 'visible' },
        cardContent: { display: 'flex', flexDirection: 'column', gap: '20px', flexGrow: 1, minHeight: 0, overflow: 'visible' },
        sectionTitle: { fontSize: '12px', letterSpacing: '0.08em', textTransform: 'uppercase', color: '#858aad', fontWeight: 600, marginBottom: '8px' },
        scheduleHeading: { fontSize: '20px', color: '#2e3192', fontWeight: 700, marginBottom: '4px' },
        scheduleSubheading: { fontSize: '14px', color: '#6c7293', marginBottom: 0 },
        timezoneChip: { backgroundColor: '#eef0ff', color: '#2e3192', borderRadius: '999px', padding: '6px 12px', fontWeight: 600, fontSize: '12px', display: 'inline-flex', alignItems: 'center' },
        expiredBadge: { backgroundColor: '#e0ffe2', color: '#28a745', borderRadius: '999px', padding: '6px 14px', fontWeight: 600, fontSize: '12px', display: 'inline-flex', alignItems: 'center', marginTop: '8px' },
        expiredRedBadge: { backgroundColor: '#ffe9e9', color: '#d9534f', borderRadius: '999px', padding: '6px 14px', fontWeight: 600, fontSize: '12px', display: 'inline-flex', alignItems: 'center', marginTop: '8px' },
        metaStack: { display: 'flex', flexDirection: 'column', gap: '8px' },
        mediaWrapper: {
            position: 'relative',
            borderRadius: '22px',
            background: 'linear-gradient(135deg, rgba(46,49,146,0.12) 0%, rgba(107,99,255,0.08) 100%)',
            padding: '18px',
            marginTop: '20px',
            overflow: 'hidden'
        },
        mediaHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' },
        mediaBadge: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: '8px',
            fontSize: '12px',
            fontWeight: 700,
            color: '#2e3192',
            backgroundColor: '#ffffff',
            borderRadius: '999px',
            padding: '8px 14px',
            letterSpacing: '0.05em',
            textTransform: 'uppercase',
            boxShadow: '0 4px 12px rgba(46,49,146,0.15)'
        },
        mediaPreviewShell: {
            borderRadius: '18px',
            backgroundColor: '#fff',
            padding: '12px',
            boxShadow: '0 8px 24px rgba(46,49,146,0.12)'
        },
        mediaPreview: {
            borderRadius: '14px',
            overflow: 'hidden',
            backgroundColor: '#0f172a',
            height: '220px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        },
        mediaFooter: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginTop: '14px',
            color: '#4f5480',
            fontSize: '12px'
        },
        mediaFilename: { fontWeight: 600, wordBreak: 'break-all' },
        captionSection: { 
            marginTop: '16px', 
            display: 'flex',
            flexDirection: 'column',
            minHeight: 0
        },
        captionSectionWithMedia: {
            marginTop: '16px', 
            display: 'flex',
            flexDirection: 'column',
            flexGrow: 1,
            minHeight: 0
        },
        contentBox: { 
            backgroundColor: '#f8f9ff', 
            borderRadius: '18px', 
            padding: '18px', 
            color: '#34385b', 
            whiteSpace: 'pre-wrap', 
            wordWrap: 'break-word', 
            overflowWrap: 'break-word', 
            overflow: 'visible', 
            display: 'block'
        },
        contentBoxWithMedia: {
            backgroundColor: '#f8f9ff', 
            borderRadius: '18px', 
            padding: '18px', 
            color: '#34385b', 
            whiteSpace: 'pre-wrap', 
            wordWrap: 'break-word', 
            overflowWrap: 'break-word', 
            overflow: 'visible', 
            display: 'block',
            flexGrow: 1
        },
        contentBoxTruncated: {
            backgroundColor: '#f8f9ff', 
            borderRadius: '18px', 
            padding: '18px', 
            color: '#34385b', 
            whiteSpace: 'pre-wrap', 
            wordWrap: 'break-word', 
            overflowWrap: 'break-word',
            overflow: 'hidden',
            position: 'relative',
            maxHeight: '250px',
            minHeight: '120px',
            height: 'auto'
        },
        contentBoxTruncatedWithMedia: {
            backgroundColor: '#f8f9ff', 
            borderRadius: '18px', 
            padding: '18px', 
            color: '#34385b', 
            whiteSpace: 'pre-wrap', 
            wordWrap: 'break-word', 
            overflowWrap: 'break-word',
            overflow: 'hidden',
            position: 'relative',
            flexGrow: 1,
            flexShrink: 1,
            flexBasis: 0,
            minHeight: '200px',
            maxHeight: '650px',
            height: 'auto',
            display: 'block'
        },
        promptBox: { backgroundColor: '#ffffff', border: '1px dashed #d9dcff', borderRadius: '18px', padding: '18px', color: '#4f5480' },
        pollBox: { backgroundColor: '#ffffff', border: '1px solid #eef0f8', borderRadius: '18px', padding: '18px', color: '#34385b', display: 'flex', flexDirection: 'column', gap: '8px' },
        pollQuestion: { fontWeight: 600, color: '#2e3192' },
        pollOption: { backgroundColor: '#f8f9ff', borderRadius: '12px', padding: '10px 14px', fontSize: '14px', color: '#4f5480' },
        actionIconButton: { borderRadius: '12px', border: '1px solid #eef0f8', backgroundColor: '#f7f8ff', padding: '10px 12px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' },
        actionIcon: { fontSize: '20px' },
        actionsWrapper: { display: 'flex', justifyContent: 'space-evenly', alignItems: 'center', gap: '16px', marginTop: '16px', width: '100%' },
        toggleLink: { marginTop: '8px', fontWeight: 600, color: '#2e3192', cursor: 'pointer', border: 'none', background: 'transparent', padding: 0 },
    };

    const ActionButton = ({ icon, label, onClick, disabled, tooltip, variant = 'outline-primary', loading = false }) => {
        const variantColor = (() => {
            switch (variant) {
                case 'success':
                    return '#28a745';
                case 'outline-danger':
                    return '#ff4d4d';
                case 'outline-dark':
                    return '#343a40';
                default:
                    return '#2e3192';
            }
        })();

        const button = (
            <button
                type="button"
                className="btn btn-icon-only"
                style={{ ...styles.actionIconButton, opacity: disabled || loading ? 0.6 : 1 }}
                onClick={onClick}
                disabled={disabled || loading}
            >
                <FontAwesomeIcon
                    icon={loading ? faSpinner : icon}
                    spin={loading}
                    style={{ ...styles.actionIcon, color: variantColor }}
                />
                <span className="visually-hidden">{label}</span>
            </button>
        );

        if (!tooltip) {
            return button;
        }

        return (
            <OverlayTrigger placement="bottom" overlay={<Tooltip id={`tooltip-${label.replace(/\s+/g, '-').toLowerCase()}`}>{tooltip}</Tooltip>}>
                <span className="d-inline-flex">{button}</span>
            </OverlayTrigger>
        );
    };

    const resolveMediaDetails = (mediaPath = '') => {
        if (!mediaPath) return null;
        const normalized = `${mediaPath}`.trim().replace(/\\/g, '/');
        if (!normalized) return null;

        const isFullUrl = /^https?:\/\//i.test(normalized);
        const isAzureBlobUrl = normalized.includes('blob.core.windows.net');
        const isLinkedInAsset = normalized.includes('linkedin.com') || normalized.includes('media.licdn.com');

        const pathWithoutQuery = normalized.split('?')[0];
        const extension = pathWithoutQuery.split('.').pop()?.toLowerCase() || '';
        const filename = pathWithoutQuery.split(/[/\\]/).pop() || '';

        let mediaType = 'unknown';
        if (['mp4', 'mov', 'avi', 'mkv', 'webm'].includes(extension)) {
            mediaType = 'video';
        } else if (['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg'].includes(extension) || isLinkedInAsset) {
            mediaType = 'image';
        }

        const source = encodeURI(
            isFullUrl || isAzureBlobUrl || isLinkedInAsset
                ? normalized
                : `${process.env.REACT_APP_API_BASE_URL}/${normalized}`
        );

        return {
            source,
            mediaType,
            filename,
        };
    };

    const renderMediaPreview = (mediaDetails) => {
        if (!mediaDetails) {
            return (
                <div className="text-muted">
                    Media not available.
                </div>
            );
        }

        if (mediaDetails.mediaType === 'video') {
            return (
                <video controls style={{ width: '100%', height: '100%', maxHeight: '320px', borderRadius: '14px' }}>
                    <source src={mediaDetails.source} />
                    Your browser does not support the video tag.
                </video>
            );
        }

        if (mediaDetails.mediaType === 'image') {
            return (
                <img
                    src={mediaDetails.source}
                    alt="Post media"
                    style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                    onError={(e) => {
                        e.currentTarget.style.display = 'none';
                    }}
                />
            );
        }

        return (
            <div className="text-muted">
                Preview not available for this file type.
            </div>
        );
    };

    const getMediaIcon = (mediaType) => (mediaType === 'video' ? faVideo : faImage);

    const getMediaLabel = (mediaType) => {
        if (mediaType === 'video') return 'Video Attachment';
        if (mediaType === 'image') return 'Image Attachment';
        return 'Media Attachment';
    };

    const getMediaInteractionHint = (mediaType) => {
        if (mediaType === 'video') return 'Tap to play';
        if (mediaType === 'image') return 'Tap to zoom';
        return 'View media';
    };

    const getMediaFilename = (mediaDetails) => {
        if (!mediaDetails) return '';
        return mediaDetails.filename;
    };

    const handleMediaPreviewClick = (mediaDetails) => {
        if (!mediaDetails || mediaDetails.mediaType === 'unknown') return;
        setActiveMedia(mediaDetails);
        setShowMediaModal(true);
    };

    const handleCloseMediaModal = () => {
        setShowMediaModal(false);
        setActiveMedia(null);
    };

    const renderModalMedia = () => {
        if (!activeMedia) return null;

        if (activeMedia.mediaType === 'video') {
            return (
                <video controls style={{ width: '100%', borderRadius: '12px' }}>
                    <source src={activeMedia.source} />
                    Your browser does not support the video tag.
                </video>
            );
        }

        if (activeMedia.mediaType === 'image') {
            return (
                <img
                    src={activeMedia.source}
                    alt={activeMedia.filename || 'Preview'}
                    style={{ width: '100%', borderRadius: '12px', objectFit: 'contain' }}
                />
            );
        }

        return null;
    };

    const toggleContent = (contentId) => {
        setExpandedPosts(prev => ({ ...prev, [contentId]: !prev[contentId] }));
    };

    const handleDate = (scheduledPostDate) => {
        // Combine date and time into a single datetime string
        const dateTimeString = `${scheduledPostDate?.split('T')[0]}`;
    
        // Parse the combined date-time string
        const dateTime = moment.utc(dateTimeString);
    
        // Format date and local time
        const date = dateTime.format('MM-DD-YYYY');
        const time = dateTime.local().format('HH:mm');
    
        return { date };
    };

    // Pagination logic
  const offset = currentPage * postsPerPage;
  const currentPosts = posts.slice(offset, offset + postsPerPage);

    const handleTime = (value) => (value ? (moment.parseZone(value, moment.ISO_8601, true).isValid() ? moment.parseZone(value, moment.ISO_8601, true).format('hh:mm A') : moment(value, 'HH:mm', true).isValid() ? moment(value, 'HH:mm', true).format('hh:mm A') : value) : '');

    const isPostExpired = (post) => {
        if (!post?.ScheduledPostDate || !post?.ScheduledTimeAsPerZone) return false;

        // Extract just the time part, ignoring the timezone (Z)
        const timePart = post.ScheduledTimeAsPerZone.split("T")[1].replace('Z', '');

        // Combine with date (ignore the time in ScheduledPostDate)
        const combinedDateTimeStr = `${post.ScheduledPostDate.split("T")[0]}T${timePart}`;

        // Force parse in the post's timezone
        const scheduledDateTime = moment.tz(combinedDateTimeStr, 'YYYY-MM-DDTHH:mm:ss', post.TimeZone);

        const now = moment().tz(post.TimeZone);

        return scheduledDateTime.isBefore(now);
    };

    const getScheduledDateTime = (post) => {
        if (!post?.ScheduledPostDate || !post?.ScheduledTimeAsPerZone) {
            // If no scheduled date, put at the end
            return moment().add(100, 'years');
        }

        // Extract just the time part, ignoring the timezone (Z)
        const timePart = post.ScheduledTimeAsPerZone.split("T")[1].replace('Z', '');

        // Combine with date (ignore the time in ScheduledPostDate)
        const combinedDateTimeStr = `${post.ScheduledPostDate.split("T")[0]}T${timePart}`;

        // Parse in the post's timezone
        return moment.tz(combinedDateTimeStr, 'YYYY-MM-DDTHH:mm:ss', post.TimeZone || 'Asia/Kolkata');
    };

    const fetchPosts = async () => {
        setLoading(true);
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/getallaigeneratedpostsbyUserID/${UserID}`);
            const approvedPosts = response.data.filter((x) => x.Status === 'APPROVED');
            
            // Separate expired and non-expired posts
            const nonExpiredPosts = approvedPosts.filter(post => !isPostExpired(post));
            const expiredPosts = approvedPosts.filter(post => isPostExpired(post));
            
            // Sort non-expired posts in ascending order by scheduled date/time
            nonExpiredPosts.sort((a, b) => {
                const dateA = getScheduledDateTime(a);
                const dateB = getScheduledDateTime(b);
                return dateA.valueOf() - dateB.valueOf();
            });
            
            // Sort expired posts in descending order (most recently expired first)
            expiredPosts.sort((a, b) => {
                const dateA = getScheduledDateTime(a);
                const dateB = getScheduledDateTime(b);
                return dateB.valueOf() - dateA.valueOf();
            });
            
            // Combine: non-expired first, then expired
            setPosts([...nonExpiredPosts, ...expiredPosts]);
            setError('');
        } catch (err) {
            console.error('Failed to fetch posts:', err.message);
            setError('Failed to fetch posts');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchPosts();
    }, [UserID]);


    // const renderMedia = (imagePath) => {
    //     if (imagePath) {
    //       // Convert backslashes to forward slashes for URLs
    //       const normalizedPath = imagePath.replace(/\\/g, '/');
    //       const fileExtension = normalizedPath.split('.').pop().toLowerCase();
    //       const fileUrl = `${process.env.REACT_APP_API_BASE_URL}/${normalizedPath}`;
      
    //       if (['mp4', 'mov', 'avi'].includes(fileExtension)) {
    //         return (
    //           <div className='mt-3 text-center'>
    //             <video width="320" height="120" controls>
    //               <source src={fileUrl} type={`video/${fileExtension}`} />
    //               Your browser does not support the video tag.
    //             </video>
    //           </div>
    //         );
    //       } else if (['jpg', 'jpeg', 'png', 'gif'].includes(fileExtension)) {
    //         return (
    //           <div className='mt-3 text-center'>
    //             <img src={fileUrl} alt="Post Media" height={100} width={100} />
    //           </div>
    //         );
    //       }
    //     }
    //     return null;
    //   };

    const handleDeactivateClick = (post) => {
        setPostToDeactivate(post);
        setShowDeactivateModal(true);
    };

    const handleConfirmDeactivate = async () => {
        if (!postToDeactivate) return;
    
        setDeactivating((prev) => ({ ...prev, [postToDeactivate.ContentId]: true }));
    
        try {
            const resp = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/deactivate-post`, 
                { ContentId: postToDeactivate.ContentId, Status: "REJECTED" },
                { headers: { 'Content-Type': 'application/json' } }
            );
    
            if (resp.data.message === 'Post deactivated successfully') {
                Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: 'Post deleted successfully',
                    showConfirmButton: false,
                    timer: 3000
                });
    
                setPosts(posts.filter(post => post.ContentId !== postToDeactivate.ContentId));
            } else {
                Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: 'Error deactivating post!',
                    showConfirmButton: false,
                    timer: 3000
                });
            }
        } catch (err) {
            console.error('Failed to deactivate post:', err.message);
            setError('Failed to deactivate post');
        } finally {
            setDeactivating((prev) => ({ ...prev, [postToDeactivate.ContentId]: false }));
            setShowDeactivateModal(false);
            setPostToDeactivate(null);
        }
    };

    const handleCloseDeactivateModal = () => {
        setShowDeactivateModal(false);
        setPostToDeactivate(null);
    };
    const handleDisapprovePost = async (ContentId) => {
        try {
            const resp = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/approve-post`, 
                { ContentId, Status: "PENDING" },
                { headers: { 'Content-Type': 'application/json' } }
            );
    
            if (resp.data.message === 'Post approved successfully') {
                Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: 'Post Disapproved successfully',
                    showConfirmButton: false,
                    timer: 3000
                });
    
                setPosts(posts.filter(post => post.ContentId !== ContentId));
            } else {
                Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: 'Error approving post!',
                    showConfirmButton: false,
                    timer: 3000
                });
            }
        } catch (err) {
            console.error('Failed to approve post:', err.message);
            setError('Failed to approve post');
        } finally {
        }
    };
    return (
        <SideNavbar>
            <div className="card shadow-sm mt-3" style={styles.pageCard}>
                <div style={styles.headerBar} className="d-flex flex-wrap justify-content-between align-items-center gap-3">
                    <Link
                        to={
                            localStorage.getItem('RoleID') == '4'
                                ? '/Pagehome'
                                : localStorage.getItem('RoleID') == '1'
                                    ? '/home'
                                    : '/adminhome'
                        }
                        className="text-decoration-none d-flex align-items-center gap-3"
                    >
                        <span className="d-inline-flex align-items-center justify-content-center rounded-circle" style={{ width: 40, height: 40, backgroundColor: '#eef0ff' }}>
                            <i className="fa fa-arrow-left" aria-hidden="true" style={{ color: '#2e3192' }}></i>
                        </span>
                        <h5 className="welcome-text" style={styles.headerTitle}>
                            Approved Posts
                        </h5>
                    </Link>

                    <button className="btn btn-outline-primary d-flex align-items-center gap-2" style={styles.refreshButton} onClick={fetchPosts}>
                        <FontAwesomeIcon icon={faRefresh} />
                        <span>Refresh</span>
                    </button>
                </div>

                <div className="container-fluid" style={{ padding: '4px 16px' }}>
                    {error && (
                        <div className="alert alert-danger d-flex align-items-center gap-2 mb-4" role="alert">
                            <FontAwesomeIcon icon={faExclamationTriangle} />
                            <span>{error}</span>
                        </div>
                    )}
                    {loading ? (
                        <div className="d-flex justify-content-center py-5">
                            <div className="spinner"></div>
                        </div>
                    ) : posts.length === 0 ? (
                        <div className="text-center py-5">
                            <img src={noDataImage} alt="No Data" style={{ width: '280px', maxWidth: '60%' }} />
                            <p style={{ color: '#2e3192', fontSize: '18px', fontWeight: 600, marginTop: '18px' }}>No approved posts yet!</p>
                            <p className="text-muted mb-0">Approved posts will show up here once your team signs off.</p>
                        </div>
                    ) : (
                        <div className="row g-4" style={styles.gridRow}>
                            {currentPosts.map((post, index) => {
                                const { date } = handleDate(post?.ScheduledPostDate);
                                const time = handleTime(post?.ScheduledTimeAsPerZone);
                                const expired = isPostExpired(post);

                                const pollRequired = post.pollrequired === true || post.pollrequired === 1 || post.pollrequired === 'true' || post.pollrequired === '1';
                                
                                // Check if QuestionwithOptions exists and is valid
                                let pollData = null;
                                let hasValidPollData = false;
                                
                                if (post.QuestionwithOptions) {
                                    try {
                                        const parsedData = typeof post.QuestionwithOptions === 'string'
                                            ? JSON.parse(post.QuestionwithOptions)
                                            : post.QuestionwithOptions;
                                        
                                        // Check if it's a valid poll structure (has question and options)
                                        if (parsedData && 
                                            typeof parsedData === 'object' && 
                                            parsedData.question && 
                                            Array.isArray(parsedData.options) && 
                                            parsedData.options.length > 0) {
                                            pollData = parsedData;
                                            hasValidPollData = true;
                                        }
                                    } catch (e) {
                                        // If parsing fails or structure is invalid, it's not a poll
                                        console.error('Error parsing poll data:', e);
                                    }
                                }
                                
                                // Only consider it a poll if pollRequired is true OR we have valid poll data
                                const isPoll = pollRequired || hasValidPollData;

                                const mediaPath = post.image || post.Image || post.ImageURL;
                                const mediaDetails = !isPoll ? resolveMediaDetails(mediaPath) : null;
                                
                                // Calculate row index (2 cards per row with col-md-6)
                                const rowIndex = Math.floor(index / 2);
                                
                                // Check if any card in the same row has media
                                const rowStartIndex = rowIndex * 2;
                                const rowEndIndex = Math.min(rowStartIndex + 2, currentPosts.length);
                                const hasMediaInRow = currentPosts.slice(rowStartIndex, rowEndIndex).some(p => {
                                    const pPollRequired = p.pollrequired === true || p.pollrequired === 1 || p.pollrequired === 'true' || p.pollrequired === '1';
                                    const pMediaPath = p.image || p.Image || p.ImageURL;
                                    return !pPollRequired && pMediaPath;
                                });

                                return (
                                    <div className="col-12 col-md-6" key={post.ContentId}>
                                        <div className="shadow-sm" style={styles.card}>
                                            <div style={styles.cardContent}>
                                                <div className="d-flex flex-wrap justify-content-between align-items-start gap-3">
                                                    <div style={styles.metaStack}>
                                                        <span style={styles.sectionTitle}>Scheduled for</span>
                                                        <div>
                                                            <div style={styles.scheduleHeading}>{date || 'Not scheduled'}</div>
                                                            <p style={styles.scheduleSubheading}>{time || 'Time not selected'}</p>
                                                        </div>
                                                    </div>
                                                    <div className="text-end d-flex flex-column align-items-end gap-2">
                                                        <span style={styles.timezoneChip}>{post?.TimeZone || 'Timezone pending'}</span>
                                                        {expired ? (
                                                            <span style={styles.expiredRedBadge}>Expired</span>
                                                        ) : (
                                                            <span style={styles.expiredBadge}>Approved</span>
                                                        )}
                                                    </div>
                                                </div>

                                                <div>
                                                    <div style={styles.sectionTitle}>Prompt</div>
                                                    <div style={styles.promptBox}>{post?.Prompts || 'No prompt provided.'}</div>
                                                </div>

                                                {mediaDetails && (
                                                    <div style={styles.mediaWrapper}>
                                                        <div style={styles.mediaHeader}>
                                                            <span style={styles.mediaBadge}>
                                                                <FontAwesomeIcon
                                                                    icon={getMediaIcon(mediaDetails.mediaType)}
                                                                    style={{ fontSize: '16px' }}
                                                                />
                                                                {getMediaLabel(mediaDetails.mediaType)}
                                                            </span>
                                                        </div>
                                                        <div style={styles.mediaPreviewShell}>
                                                            <div
                                                                style={{
                                                                    ...styles.mediaPreview,
                                                                    cursor: mediaDetails.mediaType !== 'unknown' ? 'zoom-in' : 'default'
                                                                }}
                                                                role={mediaDetails.mediaType !== 'unknown' ? 'button' : undefined}
                                                                tabIndex={mediaDetails.mediaType !== 'unknown' ? 0 : undefined}
                                                                onClick={() => handleMediaPreviewClick(mediaDetails)}
                                                                onKeyDown={(event) => {
                                                                    if (event.key === 'Enter' || event.key === ' ') {
                                                                        event.preventDefault();
                                                                        handleMediaPreviewClick(mediaDetails);
                                                                    }
                                                                }}
                                                            >
                                                                {renderMediaPreview(mediaDetails)}
                                                            </div>
                                                        </div>
                                                        <div style={styles.mediaFooter}>
                                                            <span>{getMediaInteractionHint(mediaDetails.mediaType)}</span>
                                                        </div>
                                                    </div>
                                                )}

                                                <div style={hasMediaInRow ? styles.captionSectionWithMedia : styles.captionSection}>
                                                    <div style={styles.sectionTitle}>{isPoll ? 'Poll' : 'Post Caption'}</div>
                                                    {isPoll ? (
                                                        <div style={hasMediaInRow ? { ...styles.pollBox, flexGrow: 1 } : styles.pollBox}>
                                                            {pollData?.question && (
                                                                <div style={styles.pollQuestion}>{pollData.question}</div>
                                                            )}
                                                            {Array.isArray(pollData?.options) && pollData.options.length > 0 && pollData.options.map((option, idx) => (
                                                                <div key={idx} style={styles.pollOption}>
                                                                    {option}
                                                                </div>
                                                            ))}
                                                        </div>
                                                    ) : (
                                                        <>
                                                            <div style={
                                                                expandedPosts[post.ContentId] 
                                                                    ? (hasMediaInRow ? styles.contentBoxWithMedia : styles.contentBox)
                                                                    : (hasMediaInRow ? styles.contentBoxTruncatedWithMedia : styles.contentBoxTruncated)
                                                            }>
                                                                {post?.Content || 'No content available.'}
                                                            </div>
                                                            {post?.Content && (
                                                                <button style={styles.toggleLink} onClick={() => toggleContent(post.ContentId)}>
                                                                    {expandedPosts[post.ContentId] ? 'Show Less' : 'Read More'}
                                                                </button>
                                                            )}
                                                        </>
                                                    )}
                                                </div>
                                            </div>

                                            <div className="mt-4" style={styles.actionsWrapper}>
                                                <ActionButton
                                                    icon={faTrash}
                                                    label="Delete"
                                                    variant="outline-danger"
                                                    tooltip="Delete this post"
                                                    onClick={() => handleDeactivateClick(post)}
                                                    loading={!!deactivating[post.ContentId]}
                                                />

                                                <ActionButton
                                                    icon={faArrowRotateLeft}
                                                    label="Disapprove"
                                                    variant="success"
                                                    tooltip="Move back to pending"
                                                    onClick={() => handleDisapprovePost(post.ContentId)}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    )}
                </div>

                {posts.length > postsPerPage && (
                    <ReactPaginate
                        previousLabel={"Previous"}
                        nextLabel={"Next"}
                        pageCount={Math.ceil(posts.length / postsPerPage)}
                        onPageChange={(selectedItem) => setCurrentPage(selectedItem.selected)}
                        containerClassName={"pagination"}
                        previousLinkClassName={"page-link"}
                        nextLinkClassName={"page-link"}
                        pageClassName={"page-item"}
                        pageLinkClassName={"page-link"}
                        activeClassName={"active"}
                        disabledClassName={"disabled"}
                        breakLabel={"..."}
                        breakClassName={"page-item"}
                        breakLinkClassName={"page-link"}
                    />
                )}

                <Modal show={showDeactivateModal} onHide={handleCloseDeactivateModal}>
                    <Modal.Header closeButton>
                        <Modal.Title>Delete Post</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        Are you sure you want to delete this post?
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleCloseDeactivateModal}>
                            Cancel
                        </Button>
                        <Button variant="danger" onClick={handleConfirmDeactivate}>
                            Delete
                        </Button>
                    </Modal.Footer>
                </Modal>

                <Modal show={showMediaModal} onHide={handleCloseMediaModal} size="lg" centered>
                    <Modal.Header closeButton>
                        <Modal.Title>Media Preview</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {renderModalMedia()}
                    </Modal.Body>
                </Modal>
            </div>
        </SideNavbar>
    );
};

export default ViewAllApprovedPosts;
